import React from 'react';
import { Check, Backpack, Globe, Crown } from 'lucide-react';

export const LevelsOverview: React.FC = () => {
  return (
    <section className="pt-12 pb-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 uppercase tracking-wide mb-4">
            Tri nivoa
          </h2>
          <div className="w-24 h-1 bg-go2-blue mx-auto mb-6"></div>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto">
            Putnik – Svetski Putnik – Legenda
          </p>
          <p className="text-lg text-gray-400 mt-2 max-w-2xl mx-auto">
            Svako putovanje donosi više uspomena, i poena.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-start">
          {/* Traveler */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-gray-400 flex flex-col relative hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-6 mx-auto text-gray-600">
              <Backpack className="w-8 h-8" />
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-2 text-center uppercase">Putnik</h3>
            <p className="text-sm text-gray-500 mb-8 uppercase tracking-wide font-semibold text-center">Početni nivo</p>
            
            <div className="mb-8 text-center bg-gray-50 py-4 rounded-lg">
              <span className="text-4xl font-extrabold text-gray-800">1.0x</span>
              <span className="text-gray-500 ml-2 block text-sm">množilac bodova</span>
            </div>

            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-start">
                <Check className="w-5 h-5 text-go2-blue mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-600">Bar 1 završeno putovanje</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-go2-blue mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-600">1 EUR = 1.0 bod</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-go2-blue mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-600">Do 20% popusta bodovima</span>
              </li>
            </ul>
          </div>

          {/* World Traveler */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-go2-blue flex flex-col relative hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6 mx-auto text-go2-blue">
              <Globe className="w-8 h-8" />
            </div>
            <h3 className="text-2xl font-bold text-go2-blue mb-2 text-center uppercase">Svetski Putnik</h3>
            <p className="text-sm text-gray-500 mb-8 uppercase tracking-wide font-semibold text-center">800 - 1,499 EUR</p>
            
            <div className="mb-8 text-center bg-blue-50 py-4 rounded-lg">
              <span className="text-4xl font-extrabold text-go2-blue">1.2x</span>
              <span className="text-gray-500 ml-2 block text-sm">množilac bodova</span>
            </div>

            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-start">
                <Check className="w-5 h-5 text-go2-blue mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-600 font-medium">20% više osvojenih bodova</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-go2-blue mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-600">1 EUR = 1.2 boda</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-go2-blue mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-600">Do 30% popusta bodovima</span>
              </li>
            </ul>
          </div>

          {/* Legend */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-go2-pink flex flex-col relative hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-pink-50 rounded-full flex items-center justify-center mb-6 mx-auto text-go2-pink">
              <Crown className="w-8 h-8" />
            </div>
            <h3 className="text-2xl font-bold text-go2-pink mb-2 text-center uppercase">Legenda</h3>
            <p className="text-sm text-gray-500 mb-8 uppercase tracking-wide font-semibold text-center">1500+ EUR</p>
            
            <div className="mb-8 text-center bg-pink-50 py-4 rounded-lg">
              <span className="text-4xl font-extrabold text-go2-pink">1.4x</span>
              <span className="text-gray-500 ml-2 block text-sm">množilac bodova</span>
            </div>

            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-start">
                <Check className="w-5 h-5 text-go2-pink mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-600 font-medium">40% više osvojenih bodova</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-go2-pink mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-600">1 EUR = 1.4 boda</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-go2-pink mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-600">Do 40% popusta bodovima</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
